import { lazy, type ComponentType } from "react";

const KEY = "lazy-reload-at";

// React.lazy that recovers from a stale page: if a chunk can't be fetched (a new deploy
// replaced it, or the Vite dev server re-optimized its deps), reload once to get fresh
// files instead of crashing to a blank screen. The timestamp guard prevents reload loops.
export function lazyWithReload<T extends ComponentType<any>>(load: () => Promise<{ default: T }>) {
  return lazy(() =>
    load().catch((error) => {
      const last = Number(sessionStorage.getItem(KEY) || 0);
      if (Date.now() - last > 10_000) {
        sessionStorage.setItem(KEY, String(Date.now()));
        window.location.reload();
        return new Promise<never>(() => {}); // keep suspended until the reload happens
      }
      throw error;
    })
  );
}
